import { RefObject, useLayoutEffect, useState } from "react";

/**
 * Document-relative top of `ref`, kept current across resizes.
 */
const useOffsetTop = (ref: RefObject<HTMLElement>) => {
  const [offsetTop, setOffsetTop] = useState(0);

  useLayoutEffect(() => {
    const update = () => {
      const element = ref.current;
      if (!element) {
        return;
      }
      const top = Math.round(
        element.getBoundingClientRect().top + window.scrollY,
      );
      setOffsetTop((previous) => (previous === top ? previous : top));
    };

    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, [ref]);

  return offsetTop;
};

export default useOffsetTop;
